
import { Component, OnInit, ViewEncapsulation } from '@angular/core';



@Component({
  selector: 'app-payment-redirect',
  template: require('./payment-redirect.component.html'),
  styles: [require('./payment-redirect.component.css')],
})

export class PaymentRedirectComponent implements OnInit {
  


  constructor(){}

  ngOnInit() {

  }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/payment-redirect/payment-redirect.component.ts